import { createAction } from 'redux-actions';

export const setIsMalaysiaForm = createAction('SET_IS_MALAYSIA_FORM');
export const setLang = createAction('SET_LANG');
